import { put, call, fork, select, takeEvery, all } from 'redux-saga/effects';

import * as accountsModule from '../modules/accounts.module';
import * as Api from '../../core/api';

import { reset as resetForm } from 'redux-form';

import notificationService from '../../components/notification/notificationService';

export function* fetchAccounts({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.accounts.sort);
  const filter = yield select((state) => state.accounts.filter);
  const { response, error } = yield call(Api.accounts.fetchAccounts, {
    page, itemsPerPage, sort, filter,
  });

  if (response) {
    yield put(accountsModule.fetchAccountsSuccess({ accounts: response, filter }));
  } else {
    yield put(accountsModule.fetchAccountsFail(error));
  }
}

export function* watchFetchAccounts() {
  yield takeEvery(accountsModule.fetchAccounts.getType(), fetchAccounts);
}

export function* updateAccount({ payload: { accountId, account } }) {
  const { response, error } = yield call(Api.accounts.updateAccount, { accountId, account });

  if (response) {
    yield put(accountsModule.updateAccountSuccess({
      accountId,
      updatedData: response,
    }));
    yield put(accountsModule.closeUpdateAccount());
    yield put(resetForm('addAccount'));
  } else {
    yield put(accountsModule.updateAccountFail(error));
  }
}
export function* watchUpdateAccount() {
  yield takeEvery(accountsModule.updateAccount.getType(), updateAccount);
}

export function* updateAccountStatus({ payload: { accountId, status } }) {
  const { response, error } = yield call(Api.accounts.updateAccountStatus, { accountId, status });

  if (response) {
    yield put(accountsModule.updateAccountStatusSuccess({
      accountId,
      status,
    }));
  } else {
    yield put(accountsModule.updateAccountStatusFail(error));
  }
}
export function* watchUpdateAccountStatus() {
  yield takeEvery(accountsModule.updateAccountStatus.getType(), updateAccountStatus);
}

export function* updateIsEmailConfirmed({ payload: { accountId, isEmailConfirmed } }) {
  const { response } = yield call(Api.accounts.updateIsEmailConfirmed, {
    accountId, isEmailConfirmed,
  });

  if (response) {
    yield put(accountsModule.updateIsEmailConfirmedSuccess({
      accountId,
      isEmailConfirmed,
    }));
  }
}
export function* watchUpdateIsEmailConfirmed() {
  yield takeEvery(accountsModule.updateIsEmailConfirmed.getType(), updateIsEmailConfirmed);
}

export function* massUpdateAccountsStatuses({ payload: { accountsIds, status } }) {
  const { response, error } = yield call(Api.accounts.massUpdateAccountsStatuses, { accountsIds, status });

  if (response) {
    yield put(accountsModule.massUpdateAccountsStatusesSuccess({
      accountsIds,
      status,
    }));
  } else {
    yield put(accountsModule.massUpdateAccountsStatusesFail(error));
  }
}
export function* watchMassUpdateAccountsStatuses() {
  yield takeEvery(accountsModule.massUpdateAccountsStatuses.getType(), massUpdateAccountsStatuses);
}

export function* sendEmailConfirmationMessage({ payload: accountId }) {
  const { response, error } = yield call(Api.accounts.sendEmailConfirmationMessage, accountId);

  if (response) {
    yield put(accountsModule.sendEmailConfirmationMessageSuccess());
    notificationService.showSuccessNotification(
      'Email was sent. Please confirm and update the page.'
    );
  } else {
    yield put(accountsModule.sendEmailConfirmationMessageFail(error));
    notificationService.showErrorNotification('Sorry, something went wrong.');
  }
}
export function* watchSendEmailConfirmationMessage() {
  yield takeEvery(accountsModule.sendEmailConfirmationMessage.getType(),
    sendEmailConfirmationMessage);
}

export default function* watchAccounts() {
  return yield all([
    fork(watchFetchAccounts),
    fork(watchUpdateAccount),
    fork(watchUpdateAccountStatus),
    fork(watchMassUpdateAccountsStatuses),
    fork(watchSendEmailConfirmationMessage),
    fork(watchUpdateIsEmailConfirmed),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/accounts.saga.js
 **/